import { FC, ReactNode } from "react";

import { Collapse, CollapseProps, Fade } from "@mui/material";

type CollapseAndFadeProps = {
  in: boolean;
  timeout?: number;
  onExited?: () => void;
  children: ReactNode;
} & Pick<CollapseProps, "unmountOnExit">;

export const CollapseAndFade: FC<CollapseAndFadeProps> = ({
  in: isIn,
  timeout = 300,
  onExited,
  unmountOnExit,
  children,
}) => (
  <Collapse in={isIn} timeout={timeout} onExited={onExited} unmountOnExit={unmountOnExit}>
    <Fade in={isIn} timeout={timeout}>
      <div>{children}</div>
    </Fade>
  </Collapse>
);
